import React, { useContext, useEffect, useState } from "react";
import {
  FieldButtonGroup,
  ManageFeeLayout,
  FieldDropSide,
  FieldInputNumber,
  SearchableList,
  SliderPanel,
  HierarchyComponent,
  ProrataComponent,
  LoaderWrapper,
} from "../../../components";
import ExcludedEmployeeClassification from "./ExcludedEmployeeClassification";
import {
  AddFeeApplicableTo,
  GetFeeApplicableTo,
  getEmployeeClassification,
  listInvestment,
  getSourceAndInvestmentList,
  getPlanListBasedOnFilter,
  getEmployeeClassifications,
  getFeeCalculationDetailsById,
  getInvestmentForFee,
} from "../../../services";
import { useDeepEffect, useRequest, useRouterParams } from "../../../abstracts";
import { get, isEmpty, set } from "lodash";
import ExcludedInvestments from "./ExcludedInvestments";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileInvoiceDollar,
  faInfoCircle,
} from "@fortawesome/pro-light-svg-icons";
import {
  FLOW_TYPES,
  FeesApplicableOptions,
  MANAGE_FEE_ROUTES,
  formFields,
  getAdvancedPathWithParam,
  manageFeeFormNames,
  ROUTES,
  deductFeeOption,
  synchronizeCollectionNew,
  synchronizeCollectionPlanGroups,
} from "../../../utils";
import FeesApplicableToAddPlan from "./FeesApplicableToAddPlan";
import FeesApplicableToAddPlanGroups from "./FeesApplicableToAddPlanGroups";
import { Field, Form, Formik } from "formik";
import { Button } from "react-bootstrap";
import {
  manageFeeStore,
  setBasicFeeData,
  setFeeIdInfo,
  setManageFeeApplicableData,
  setManageFeeToastInfo,
  setManagePlanToastInfo,
} from "../../../contexts";
import PlanSliderPanelPopUp from "../../../components/PlanSliderPanelPopUp/PlanSliderPanelPopUp";

const AllocationOptions = [
  {
    label: "Source Hierarchical Investment Prorate",
    value: 1,
  },
  {
    label: "Investment Hierarchical Source Prorate",
    value: 2,
  },
  {
    label: "Source & Investment Prorate",
    value: 3,
  },
];
const ApplicableToContainer = (props) => {
  //constants
  const { history } = props;
  const { state, dispatch } = useContext(manageFeeStore);
  const { flow, feeId } = useRouterParams();

  const buttons = [
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      link: ROUTES.FEE,
      flow: [FLOW_TYPES.ADD],
    },
    {
      label: "Next",
      variant: "primary",
      type: "submit",
      flow: [FLOW_TYPES.ADD],
    },
  ];

  const editbuttons = [
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      flow: [FLOW_TYPES.EDIT, FLOW_TYPES.SAVE],
      link: ROUTES.FEE,
    },
    {
      label: "Next",
      variant: "primary",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      onClick: () =>
        history.push(
          getAdvancedPathWithParam({
            path: MANAGE_FEE_ROUTES.SCHEDULE_OR_RUN,
            pathParam: [FLOW_TYPES.EDIT, feeId],
          })
        ),
    },
    // {
    //   label: "Edit",
    //   variant: "primary",
    //   type: "button",
    //   flow: [FLOW_TYPES.EDIT],
    //   onClick: () =>
    //     history.push(
    //       getAdvancedPathWithParam({
    //         path: MANAGE_FEE_ROUTES.APPLICABLE_TO,
    //         pathParam: [FLOW_TYPES.SAVE, feeId],
    //       })
    //     ),
    // },
    {
      label: "Save & Proceed",
      variant: "primary",
      type: "submit",
      flow: [FLOW_TYPES.SAVE],
    },
  ];

  const formName = manageFeeFormNames.APPLICABLE_TO;
  const fields = formFields[formName];
  const isEdit = flow === FLOW_TYPES.EDIT;
  const isSave = flow === FLOW_TYPES.SAVE;

  //States
  const [apiResponse, setApiResponse] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [employeeClassifications, setEmployeeClassifications] = useState([]);
  const [totalInvestment, setTotalInvestment] = useState([]);
  const [excludedInvestment, setExcludedInvestment] = useState([]);
  const [finalExcludedInvestment, setFinalExcludedInvestment] = useState([]);
  const [employeeClassification, setEmployeeClassification] = useState([]);
  const [allPlans, setAllPlans] = useState([]);
  const [investmentsData, setInvestmentsData] = useState([]);
  const [activePlans, setActivePlans] = useState([]);
  const [savePlans, setSavePlans] = useState([]);
  const [savePlanGroup, setSavePlanGroup] = useState([]);
  const [saveexcludedPlans, setSaveExcludedPlans] = useState([]);
  const [plansForExcluded, setPlansForExcluded] = useState([]);
  const [errorMsg, setErrorMsg] = useState("");
  const [errorPlanGroups, setErrorPlanGroups] = useState("");
  const [planDetails, setPlanDetails] = useState();
  const [sources, setSources] = useState([]);
  const [investmentsHeir, setInvestmentsHeir] = useState([]);
  const [isSliderOpen, setSliderOpen] = useState(false);
  const [activePlansFilter, setActivePlansFilter] = useState([]);
  const [searchActivePlans, setSearchActivePlans] = useState("");
  const [investmentInformation, setInvestmentInformation] = useState("");
  const [calculationDetails, setCalculationDetails] = useState([]);

  useDeepEffect(() => {
    setIsLoading(true);
    GetFeeApplicableTo(feeId).then((response) => {
      setIsLoading(false);
      setApiResponse(response);
      if (response?.applicableTo == 2) {
        setSavePlans(response?.planMappings);
      } else if (response?.applicableTo == 3)
        setSavePlanGroup(response?.planGroupMappings);
      setSaveExcludedPlans(response?.excludedPlanMappings);
      dispatch(
        setFeeIdInfo({
          id: response?.feeId,
          step: response?.step,
        })
      );
    });
    getFeeCalculationDetailsById(feeId).then((res) => {
      if (res.calculationDetails.investmentId != null) {
        setCalculationDetails(res.calculationDetails);
        getInvestmentForFee(res.calculationDetails.investmentId).then(
          (response) => {
            setInvestmentInformation(response);
          }
        );
      } else {
        setInvestmentInformation("");
      }
    });
  }, []);

  useDeepEffect(() => {
    getPlanListBasedOnFilter({
      planType: [],
      statusType: [3],
      advisor: [],
      clearingPartner: [],
      planGroup: [],
      investment: investmentInformation?.id,
    }).then((response) => {
      setActivePlans(response);
      setActivePlansFilter(response);
    });
  }, [investmentInformation]);

  useDeepEffect(() => {
    let plans = savePlans;
    setPlansForExcluded(plans);
    if (plans?.length == 1) {
      let planId = plans[0]?.planId;
      setPlanDetails(plans);
      listInvestment(planId).then((response) => {
        if (!isEmpty(response?.investmentPlanMappings)) {
          const listId = !isEmpty(apiResponse?.excludedInvestments)
            ? apiResponse?.excludedInvestments.map((item) => item.investmentId)
            : [];

          setInvestmentsData(
            response?.investmentPlanMappings?.map((e) => {
              if (listId.includes(e.id)) {
                return {
                  investmentId: e.id,
                  cusip: e.cusip,
                  name: e.name,
                  excluded: true,
                };
              } else {
                return {
                  investmentId: e.id,
                  cusip: e.cusip,
                  name: e.name,
                  excluded: false,
                };
              }
            })
          );
        }
      });
      getSourceAndInvestmentList(planId).then((response) => {
        if (response?.isSuccessfull) {
          setInvestmentsHeir(response?.investmentTypes);
          setSources(response?.sourceLists);
        }
      });
    }
    if (plans?.length == 1 && !isEmpty(allPlans)) {
      let companyId = allPlans.filter((x) => x.planId == plans[0]?.planId)[0]
        ?.companyId;
      getEmployeeClassifications(companyId).then((response) => {
        setEmployeeClassifications(
          response?.map((item) => {
            return {
              codeName: item.codeName,
              code: item.code,
              employeeClassificationCodeId: item.id,
            };
          })
        );
      });
    }
  }, [savePlans, allPlans]);

  //Funstions
  console.log(employeeClassification.filter((x) => x.classificationCheck));
  console.log(
    "intersection1",
    investmentsData.filter((x) => x.excluded)
  );
  console.log(
    "intersection",
    apiResponse?.excludedInvestments ??
      [].filter((x) =>
        investmentsData
          .filter((x) => x.excluded)
          .every((x2) => x2.investmentId == x.investmentId)
      )
  );

  const getDataForSave = (values) => {
    let saveGroup = [];
    savePlanGroup?.map((plan) => {
      saveGroup = [
        ...saveGroup,
        {
          ...plan,
          planGroupId: plan.planGroupId,
        },
      ];
    });

    const updatedValues = {
      feeId: parseInt(feeId),
      step: 3,
      applicableTo: values[fields.applicableTo],
      allocationMethod: values[fields.allocationMethod],
      collectFeeFromOnlyThisInvestment: false,
      excludedInvestments:
        values[fields.applicableTo] === 2 && savePlans.length == 1
          ? synchronizeCollectionPlanGroups(
              apiResponse?.excludedInvestments ?? [],
              investmentsData.filter((x) => x.excluded),
              "investmentId"
            )
          : synchronizeCollectionPlanGroups(
              apiResponse?.excludedInvestments ?? [],
              [],
              "investmentId"
            ),
      excludedEmployeeClassifications:
        values[fields.applicableTo] === 2 && savePlans.length == 1
          ? synchronizeCollectionPlanGroups(
              apiResponse?.excludedEmployeeClassifications ?? [],
              employeeClassification.filter((x) => x.classificationCheck),
              "employeeClassificationCodeId"
            )
          : synchronizeCollectionPlanGroups(
              apiResponse?.excludedEmployeeClassifications ?? [],
              [],
              "employeeClassificationCodeId"
            ),
      investmentHeirarchy:
        values[fields.allocationMethod] == 2
          ? values.investmentHeirarchy?.map((val) => ({
              ...val,
              isDeleted: !investmentsHeir.find(
                (_) => _.investmentTypeId == val.investmentTypeId
              ),
            }))
          : synchronizeCollectionNew(
              apiResponse.investmentHeirarchy ?? [],
              [],
              "investmentTypeId"
            ),
      sourceHeirarchy:
        values[fields.allocationMethod] == 1
          ? values.sourceHeirarchy?.map((val) => ({
              ...val,
              isDeleted: !sources.find((_) => _.sourceId == val.sourceId),
            }))
          : synchronizeCollectionNew(
              apiResponse.sourceHeirarchy ?? [],
              [],
              "sourceId"
            ),
      deductFeeFrom: values[fields.deductFeeFrom],
      planMappings:
        values[fields.applicableTo] === 2
          ? synchronizeCollectionPlanGroups(
              apiResponse.planMappings ?? [],
              savePlans ?? [],
              "planId"
            )
          : synchronizeCollectionPlanGroups(
              apiResponse.planMappings ?? [],
              [],
              "planId"
            ),
      planGroupMappings: synchronizeCollectionPlanGroups(
        apiResponse.planGroupMappings ?? [],
        saveGroup ?? [],
        "planGroupId"
      ),
      excludedPlanMappings:
        values[fields.applicableTo] === 3
          ? synchronizeCollectionPlanGroups(
              apiResponse.excludedPlanMappings ?? [],
              saveexcludedPlans ?? [],
              "planId"
            )
          : synchronizeCollectionPlanGroups(
              apiResponse.excludedPlanMappings ?? [],
              [],
              "planId"
            ),
    };

    return updatedValues;
  };

  const onFormSubmit = (values, { setFieldError, setFieldTouched }) => {
    const data = getDataForSave(values);
    setIsLoading(true);
    AddFeeApplicableTo(data)
      .then((response) => {
        setIsLoading(false);
        if (response.isSuccessfull) {
          dispatch(
            setManageFeeToastInfo({
              showToast: true,
              toastMessage: "Data saved successfully",
            })
          );
          dispatch(setManageFeeApplicableData(response));
          dispatch(
            setFeeIdInfo({
              id: response.feeApplicableTo.feeId,
              step: response.feeApplicableTo.step,
            })
          );

          history.push(
            getAdvancedPathWithParam({
              path: MANAGE_FEE_ROUTES.SCHEDULE_OR_RUN,
              pathParam:
                response?.feeApplicableTo.step >= 5
                  ? [FLOW_TYPES.SAVE, feeId]
                  : [feeId],
            })
          );
        } else {
          setApiResponse(response.feeApplicableTo);
          setIsLoading(false);
          for (var i = 0; i < response.errorMessages.length; i++) {
            var _ = response.errorMessages[i];
            setFieldTouched(_.controlName, true);
            setFieldError(_.controlName, `${_.errorCode} : ${_.message}`);
            if (_.controlName === "plans") {
              setErrorMsg(`${_.errorCode} : ${_.message}`);
            }
            if (_.controlName === "planGroups") {
              setErrorPlanGroups(`${_.errorCode} : ${_.message}`);
            }
          }
        }
      })
      .catch((error) => setIsLoading(false));
  };

  useDeepEffect(() => {
    setActivePlansFilter(
      activePlans.filter((team) => {
        return (
          team.planName
            .toLowerCase()
            .includes(searchActivePlans.toLowerCase()) ||
          team.rkPlanNumber.includes(searchActivePlans)
        );
      })
    );
  }, [searchActivePlans]);

  return (
    <LoaderWrapper isLoading={isLoading}>
      <Formik
        onSubmit={onFormSubmit}
        initialValues={{
          [fields.allocationMethod]: apiResponse?.allocationMethod,
          [fields.applicableTo]: apiResponse?.applicableTo,
          [fields.deductFeeFrom]: apiResponse?.deductFeeFrom ?? 1,
          sourceHeirarchy:
            apiResponse?.allocationMethod == 1
              ? get(apiResponse, "sourceHeirarchy", [])
              : [],
          investmentHeirarchy:
            apiResponse?.allocationMethod == 2
              ? get(apiResponse, "investmentHeirarchy", [])
              : [],
        }}
        enableReinitialize
        validateOnChange={false}
        validateOnBlur={false}
      >
        {({
          handleChange,
          setFieldValue,
          setValues,
          setFieldError,
          setTouched,
          setFieldTouched,
          handleSubmit,
          setErrors,
          values,
          ...rest
        }) => {
          const onApplicableChange = (value) => {
            setFieldValue(fields.applicableTo, value);
            setFieldValue(fields.deductFeeFrom, 1);
            setFieldValue(fields.allocationMethod, null);
          };
          const applicableTo = values[fields.applicableTo];
          return (
            <Form
              autoComplete="off"
              className="h-100"
              onSubmit={handleSubmit}
              validated={!isEmpty(rest.errors)}
            >
              <ManageFeeLayout
                isCreateFee={true}
                layoutHeader={"Applicable To"}
                buttons={apiResponse.step >= 5 ? editbuttons : buttons}
                pageFlow={flow}
              >
                <div style={{ height: "80vh", overflow: "scroll" }}>
                  {!isEmpty(investmentInformation) && (
                    <>
                      <div className="investment-feeApp mb-20">
                        <div className="headerfont-investment mb-10">
                          Selected Investment
                        </div>
                        <div className="bodyfont-investment mb-10">
                          {investmentInformation?.name}
                        </div>
                        <div className="headerfont-investment">
                          {investmentInformation?.cusip}
                        </div>
                      </div>
                      <div className="info-inv">
                        <FontAwesomeIcon
                          icon={faInfoCircle}
                          className="info-circle"
                        />
                        <p className="info-style">
                          {`Select all or specific plans/groups pertaining to the Investment`}
                        </p>
                        <p className="info-heading">
                          {investmentInformation?.name}
                        </p>
                      </div>
                    </>
                  )}
                  <p className="addedPlans-card-font">Fees applicable to</p>
                  <Field
                    isRequired
                    name={fields.applicableTo}
                    size="sm"
                    options={FeesApplicableOptions}
                    selectedValue={values[fields.applicableTo]}
                    onChange={(value) => {
                      onApplicableChange(value);
                      if (value != 2) setFieldValue(fields.allocationMethod, 3);
                    }}
                    component={FieldButtonGroup}
                    disabled={isEdit && !isSave}
                  />
                  {applicableTo === 1 && (
                    <div>
                      <PlanSliderPanelPopUp
                        isSliderOpen={isSliderOpen}
                        savedPlans={activePlans}
                        setSliderOpen={setSliderOpen}
                        setSearchSavedPlans={setSearchActivePlans}
                        savedPlansFilter={activePlansFilter}
                        header="Plans added to the fee"
                        isMapper={false}
                        status="Active"
                      />

                      <div className="fees-all-plans-box mb-20">
                        <div className="addedPlans-card-font"> Plans added</div>
                        <div className="d-flex">
                          <FontAwesomeIcon
                            icon={faFileInvoiceDollar}
                            className="mt-20"
                          />
                          <div
                            onClick={() => {
                              setSliderOpen(true);
                            }}
                            style={{ color: "royalblue", cursor: "pointer" }}
                            className="allplans-font ml-10 mt-15"
                          >
                            {activePlans.length}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {applicableTo === 2 && (
                    <FeesApplicableToAddPlan
                      allPlans={allPlans}
                      setAllPlans={setAllPlans}
                      setSavePlans={setSavePlans}
                      savePlans={savePlans}
                      setFieldValue={setFieldValue}
                      errorMsg={errorMsg}
                      investmentInformation={investmentInformation}
                      isEdit={isEdit}
                      isSave={isSave}
                    />
                  )}

                  {applicableTo === 3 && (
                    <FeesApplicableToAddPlanGroups
                      setSavePlanGroup={setSavePlanGroup}
                      savePlanGroup={savePlanGroup}
                      saveexcludedPlans={saveexcludedPlans}
                      setSaveExcludedPlans={setSaveExcludedPlans}
                      errorPlanGroups={errorPlanGroups}
                      investmentInformation={investmentInformation}
                    />
                  )}
                  {applicableTo == 2 && plansForExcluded.length == 1 && (
                    <>
                      <ExcludedEmployeeClassification
                        planDetails={planDetails}
                        employeeClassifications={
                          !isEmpty(employeeClassifications)
                            ? employeeClassifications
                            : []
                        }
                        setEmployeeClassifications={setEmployeeClassifications}
                        employeeClassification={employeeClassification}
                        setEmployeeClassification={setEmployeeClassification}
                        initialEmployeeClassification={
                          apiResponse?.excludedEmployeeClassifications
                        }
                        isEdit={isEdit}
                        isSave={isSave}
                      />
                      <div className="Fee-section-head addedPlans-card-font ft-18">
                        Fee Allocation Method
                      </div>
                      <ExcludedInvestments
                        investmentsData={investmentsData}
                        setInvestmentsData={setInvestmentsData}
                        totalInvestment={totalInvestment}
                        setTotalInvestment={setTotalInvestment}
                        excludedInvestment={excludedInvestment}
                        setExcludedInvestment={setExcludedInvestment}
                        finalExcludedInvestment={finalExcludedInvestment}
                        setFinalExcludedInvestment={setFinalExcludedInvestment}
                        initialSavedInvestments={
                          apiResponse?.excludedInvestments
                        }
                        isEdit={isEdit}
                        isSave={isSave}
                      />
                    </>
                  )}
                  <p className="addedPlans-card-font">Deduct Fee from</p>
                  <Field
                    isRequired
                    name={fields.deductFeeFrom}
                    size="sm"
                    options={deductFeeOption}
                    selectedValue={values[fields.deductFeeFrom]}
                    onChange={(val) => setFieldValue(fields.deductFeeFrom, val)}
                    component={FieldButtonGroup}
                    disabled={isEdit && !isSave}
                  />
                  {!calculationDetails?.feeToBeCollectedFromOnlySelectedInvestment && (
                    <>
                      <div className="addedPlans-card-font mb-10">
                        Allocation Method
                      </div>
                      <Field
                        size="md"
                        isRequired
                        name={fields.allocationMethod}
                        value={values[fields.allocationMethod]}
                        options={
                          values[fields.applicableTo] == 2 &&
                          savePlans.length == 1
                            ? AllocationOptions
                            : AllocationOptions.filter((x) => x.value == 3)
                        }
                        placeholder="Select"
                        direction="right"
                        popupContent={
                          <SearchableList
                            label="Select"
                            options={
                              values[fields.applicableTo] == 2 &&
                              savePlans.length == 1
                                ? AllocationOptions
                                : AllocationOptions.filter((x) => x.value == 3)
                            }
                            onSelect={(value) => {
                              setValues({
                                ...values,
                                [fields.allocationMethod]: value,
                              });
                            }}
                            selectedValue={values[fields.allocationMethod]}
                          />
                        }
                        component={FieldDropSide}
                        disabled={isEdit && !isSave}
                      />
                    </>
                  )}

                  {values[fields.allocationMethod] == 1 && (
                    <>
                      <HierarchyComponent
                        header={"Source"}
                        subHeading={"Source Type"}
                        fieldName="sourceHeirarchy"
                        list={sources}
                        allocationMethod={values[fields.allocationMethod]}
                        handleChange={handleChange}
                        isEdit={isEdit}
                        isSave={isSave}
                        values={values}
                        name="sourceId"
                      />
                      <ProrataComponent
                        header={"Investments"}
                        list={investmentsHeir}
                      />
                    </>
                  )}
                  {values[fields.allocationMethod] == 2 && (
                    <>
                      <HierarchyComponent
                        header={"Investment"}
                        subHeading={"Investment type"}
                        fieldName={"investmentHeirarchy"}
                        list={investmentsHeir}
                        allocationMethod={values[fields.allocationMethod]}
                        handleChange={handleChange}
                        isEdit={isEdit}
                        isSave={isSave}
                        values={values}
                        name="investmentTypeId"
                      />
                      <ProrataComponent header={"Source"} list={sources} />
                    </>
                  )}
                </div>
              </ManageFeeLayout>
            </Form>
          );
        }}
      </Formik>
    </LoaderWrapper>
  );
};
export default ApplicableToContainer;
